<nav class="navbar w-100 d-flex justify-content-between flex-wrap">
  <div class="d-flex align-items-center position-relative">
    <h2>CVU Backoffice</h2>
  </div>
  <ul class="navbar-nav">
    <li class="nav-item dropdown mb-0">
      <button class="nav-link dropdown-toggle p-0" role="button" data-bs-toggle="dropdown" aria-expanded="false">
        <img src="\assets\icons\profile.svg" alt="">{{username}}
      </button>
      <ul class="dropdown-menu dropdown-menu-end position-absolute">
        <li class="d-flex">
          <img src="\assets\icons\shield.svg" alt="">
          <a class="dropdown-item" routerLink="/profile">Perfil</a>
        </li>
        <li>
        </li>
        <li class="d-flex">
          <img src="\assets\icons\logout.svg" alt="">
          <button class="dropdown-item" routerLink="/auth/login" (click)="logout()">Cerrar sesión</button>
        </li>
      </ul>
    </li>
  </ul>
</nav>
